<template>
  <div id="terms">
    <div class="container">
      <div class="terms-container">
        <div class="contents" v-html="input"></div>
      </div>

      <div class="button-group" v-if="isSignUp">
        <div class="button" @click="onTermsAgreeClick">Agree</div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import axios from 'axios'
import common from '@/utils/common'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'TermsConditions',
  mixins: [common],
  components: {
    CompLoading
  },
  created() {
    if (this.$route.params.userID) {
      this.userID = this.$route.params.userID
    }
    this.socialType = this.$route.params.socialType

    this.$parent.setNav(this.isShowMenus)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.headerBack = this.isMobile && this.isEmpty(this.socialType)
    this.$parent.setBottomTab(false)

    this.loadTermsOfUseFile()
  },
  data() {
    return {
      pageTitle: 'Terms & Conditions',
      isShowMenus: this.$route.params.isShowMenus || false,

      isLoading: false,

      termsOfUseFileName: 'TermsOfUse.html',
      privacyPolicyFileName: 'PrivacyPolicy.html',
      input: '',

      userID: '',
      socialType: ''
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
    isSignUp() {
      return this.$route.params.socialType || this.$route.params.isSignUp
    }
  },
  methods: {
    loadTermsOfUseFile() {
      axios({
        method: 'get',
        url: `./${this.termsOfUseFileName}`,
        baseURL: ''
      }).then(({ data }) => {
        this.input = data
        this.loadPrivacyPolicyFile()
      })
    },
    loadPrivacyPolicyFile() {
      axios({
        method: 'get',
        url: `./${this.privacyPolicyFileName}`,
        baseURL: ''
      }).then(({ data }) => {
        this.input += data
      })
    },
    onTermsAgreeClick() {
      if (this.isEmpty(this.userID)) {
        localStorage.setItem('tempTermsAgree', true)
        this.goBack()
      } else {
        this.isLoading = true

        const user = {
          userId: this.userID,
          password: '',
          type: this.socialType
        }
        this.$store.dispatch('auth/register', user).then((data) => {
          this.isLoading = false

          if (data.resultCode === 0) {
            this.goPageWithParams('Signin', {
              socialType: this.socialType,
              userID: this.userID
            })
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/terms.scss" scoped></style>
